import comp from "./NotAddedEmptyView";
export default comp;
